import { ApiCaller, callApi, getUrlWithPathParams } from 'services/api'
import { normalizeDataForApi } from 'utils'

import { FundingRound } from './types'

const FUNDING_ROUND_ENDPOINT_PATH = '/funding-rounds/'

const apiGetAllFundingRounds = (apiCaller: ApiCaller) => async (companyId: number): Promise<FundingRound[]> => {
  const fundingRounds = await apiCaller<FundingRound[]>({
    url: FUNDING_ROUND_ENDPOINT_PATH,
    params: {
      companyId,
      include: ['investments'],
    },
  })
  return fundingRounds.map((fundingRound) => normalizeApiFundingRound(fundingRound))
}

export const apiGetAllFundingRoundsAsCurrentUser = apiGetAllFundingRounds(callApi)
export const apiGetAllFundingRoundsAsAdmin = apiGetAllFundingRounds(callApi)

const apiPutFundingRound = (apiCaller: ApiCaller) => async (
  fundingRound: FundingRound,
  companyId: number
): Promise<FundingRound> => {
  const updatedFundingRound = await apiCaller<FundingRound>({
    method: 'put',
    url: getUrlWithPathParams(FUNDING_ROUND_ENDPOINT_PATH, fundingRound.id),
    data: {
      ...normalizeDataForApi(fundingRound),
      companyId,
    },
  })
  return normalizeApiFundingRound(updatedFundingRound)
}

export const apiPutFundingRoundAsCurrentUser = apiPutFundingRound(callApi)
export const apiPutFundingRoundAsAdmin = apiPutFundingRound(callApi)

const apiPostFundingRound = (apiCaller: ApiCaller) => async (
  fundingRound: FundingRound,
  companyId: number
): Promise<FundingRound> => {
  const updatedFundingRound = await apiCaller<FundingRound>({
    method: 'post',
    url: FUNDING_ROUND_ENDPOINT_PATH,
    data: {
      ...normalizeDataForApi(fundingRound),
      companyId,
    },
  })
  return normalizeApiFundingRound(updatedFundingRound)
}

export const apiPostFundingRoundAsCurrentUser = apiPostFundingRound(callApi)
export const apiPostFundingRoundAsAdmin = apiPostFundingRound(callApi)

const apiDeleteFundingRound = (apiCaller: ApiCaller) => async (fundingRound: FundingRound): Promise<void> => {
  return await apiCaller<void>({
    method: 'delete',
    url: getUrlWithPathParams(FUNDING_ROUND_ENDPOINT_PATH, fundingRound.id),
  })
}

export const apiDeleteFundingRoundAsCurrentUser = apiDeleteFundingRound(callApi)
export const apiDeleteFundingRoundAsAdmin = apiDeleteFundingRound(callApi)

function normalizeApiFundingRound(fundingRound: FundingRound): FundingRound {
  const { announcedOn, closedOn, ...fundingRoundData } = fundingRound
  return {
    ...fundingRoundData,
    announcedOn: announcedOn ? new Date(announcedOn) : undefined,
    closedOn: closedOn ? new Date(closedOn) : undefined,
  }
}
